<ion-row class="ion-justify-content-center no-data-found" [style.height.%]="height" [style.width.%]="width">
  <ion-col class="ion-align-self-center ion-text-center padding-col">
    <ion-text class="lbl-16" [style.fontSize.px]="fontSize">{{message | getLanguagePipe}}</ion-text>
  </ion-col>
</ion-row>
<!-- style="text-transform: uppercase;"  -->